import { useSelector } from 'react-redux';
import { useOnResizeValue } from '../../../../shared/hooks/useOnResizedValue';
import { beatsSelector } from '../../../beats/beats.selector';
import { useAxisScale } from '../../../plot/hooks/useAxisScale';
import { useScale } from '../../../plot/hooks/useScale';
import { getDurationFromNumberOfPoints } from '../../client/helpers';
import {
  clusterVerticalRangeSelector,
  projectedBaseClusterSelector,
} from '../../selectors/cluster.selectors';
import {
  ClusterPlotContainer,
  PLOT_HEIGHT_PERCENTAGE,
  PLOT_WIDTH_PERCENTAGE,
} from '../genericClusterPlotUtils/ClusterPlotContainer';
import { ClusterGraph } from './ClusterGraph';

const NUMBER_OF_POINTS = 400;

export const ClusterPlot: React.FC = () => {
  const cluster = useSelector(projectedBaseClusterSelector);
  const beats = useSelector(beatsSelector);
  const { yMin, yMax } = useSelector(clusterVerticalRangeSelector);
  const height = useOnResizeValue(
    () => window.innerHeight * PLOT_HEIGHT_PERCENTAGE,
  );
  const width = useOnResizeValue(
    () => window.innerWidth * PLOT_WIDTH_PERCENTAGE,
  );
  const xScale = useAxisScale({
    size: getDurationFromNumberOfPoints(NUMBER_OF_POINTS),
    end: width,
  });
  const yScale = useScale({
    domain: { start: yMax, end: yMin },
    range: { end: height },
  });

  if (cluster == null) {
    return <></>;
  }

  return (
    <ClusterPlotContainer
      xScale={xScale}
      yScale={yScale}
      duration={NUMBER_OF_POINTS}
    >
      <ClusterGraph
        height={height}
        yScale={yScale}
        xScale={xScale}
        beats={beats}
      />
    </ClusterPlotContainer>
  );
};
